import { render } from "./TravelSplashScreen.vue?vue&type=template&id=6f3a8bea&scoped=true"
import script from "./TravelSplashScreen.vue?vue&type=script&lang=js"
export * from "./TravelSplashScreen.vue?vue&type=script&lang=js"

import "./TravelSplashScreen.vue?vue&type=style&index=0&id=6f3a8bea&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3a8bea"]])

export default __exports__